import { Button, Modal, Divider, Table, Typography } from "antd";
import moment from "moment";

import { formatDate } from "utils/helpers";

import DiagnosisHistoryModalProps from './Proptypes';
import { ORGANIZATION_NAME } from "utils/objects";

const { Title } = Typography;


const diagnosisHistoryColumns = [
  {
    title: "HCC",
    key: "RmiHccCode",
    dataIndex: "RmiHccCode",
  },
  {
    title: "ICD CODE",
    key: "RmiDiagCode",
    dataIndex: "RmiDiagCode",
  },
  {
    title: "Date of Service",
    key: "cpt",
    dataIndex: "dateOfService",
    render: (_: string, record: any, __: number) => formatDate(record.RmiDateOfService, 'MM/DD/YYYY'),
    sorter: (a: any, b: any) => a.RmiDateOfService.localeCompare(b.RmiDateOfService)
  },
  {
    title: "Provider",
    key: "RmiProvider",
    dataIndex: "RmiProvider",
  },
  {
    title: "Year",
    key: "RmiYear",
    dataIndex: "RmiYear",
    sorter: (a: any, b: any) => a.RmiYear - b.RmiYear
  }
];

const DiagnosisHistoryModal = (props: DiagnosisHistoryModalProps) => {
  const handleCancel = () => {
    return props.isModalVisibleHandler();
  };

  return (
    <Modal
      visible={props.isModalVisible}
      okText="Submit"
      width={1000}
      cancelText="Cancel"
      maskClosable={true}
      onCancel={handleCancel}
      footer={[
        <>
          <div className="text-center">
            Copyright {ORGANIZATION_NAME}, Inc. © {moment().year()}
          </div>
          <Button key="cancel" onClick={handleCancel}>
            Close
          </Button>
        </>
      ]}
    >
      <div className="row flex-lg-wrap justify-content-center">
        <Title level={4}>{props.hccCode} Diagnosis History</Title>
        <div className="claim-history-detail-form-modal row flex-lg-wrap justify-content-start ml-3 mr-3">
          <div className="col-lg-8 col-md-8 mb-4">
            <div className="row mt-3">
              <div className="bold col-lg">
                Patient Name:
              </div>
              <div className="col-lg">
                {props.eligibilityMemberInfo.RmiLastName}, {props.eligibilityMemberInfo.RmiFirstName}
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-8 mb-4">
            <div className="row mt-3">
              <div className="bold col-lg">
                DOB:
              </div>
              <div className="col-lg">
                {formatDate(props.eligibilityMemberInfo.RmiBirth, 'MM/DD/YYYY')}
              </div>
            </div>
          </div>

          <div className="col-lg-8 col-md-8 mb-4">
            <div className="row mt-3">
              <div className="bold col-lg">
                Gender:
              </div>
              <div className="col-lg">
                {props.eligibilityMemberInfo.RmiSex}
              </div>
            </div>
          </div>

          <Divider className="claim-history-detail-form-modal-divider" />

          <div className="col-lg-24">
            <Table
              columns={diagnosisHistoryColumns}
              dataSource={props.dataSource}
              loading={props.isFetchingDetails}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DiagnosisHistoryModal;
